import React from 'react';
import classNames from 'classnames';

interface Props {
    planDetails: {
        id: number;
        name: string;
        price: string;
        features: string | React.ReactElement;
    };
    selected: boolean;
    onSelect: () => void;
}

const PlanOption = ({ planDetails: { name, price, features }, selected, onSelect }: Props) => {
    const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            onSelect();
        }
    };

    return (
        <div
            onClick={onSelect}
            onKeyPress={handleKeyPress}
            tabIndex={1}
            className={classNames({
                'relative flex-1 mx-4 p-5 rounded-lg shadow-md cursor-pointer hover:scale-105 transition duration-200 border border-2 ': true,
                'border-blue-dark': selected,
                'border-transparent': !selected,
            })}>
            <div
                className={classNames({
                    'absolute top-3 right-3 h-4 w-4 rounded-full transition duration-200 border-grey-light': true,
                    'border-4 border-blue-dark': selected,
                    'border-2': !selected,
                })}></div>
            <div className="my-4 text-lg font-semibold h-12">{name}</div>
            <div className="my-4 text-lg">{price}</div>
            <div className="my-4">{features}</div>
        </div>
    );
};

export default PlanOption;
